export const encodeMetricId = (bc: string, sc: string, fc: string) => {
  return `${bc}:${sc}:${fc}`;
};

export const decodeMetricId = (id: string) => {
  const split = id.split(":");
  return { buildingID: split[0], strategyID: split[1], floorID: split[2] };
};
